import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box
} from '@mui/material';

const ModelSelector = ({ models, selectedModel, onModelChange }) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, color: '#666' }}>
        Model
      </Typography>
      <FormControl size="small" fullWidth>
        <Select
          value={selectedModel}
          onChange={onModelChange}
          variant="outlined"
          sx={{
            bgcolor: '#f8f9fa',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.1)'
            }
          }}
        >
          {models.map((model) => (
            <MenuItem key={model} value={model}>
              {model}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ModelSelector;
